import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Navbar } from "@/components/Navbar";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import api, { apiErr } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function Login() {
  const { setUser } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", form);
      setUser(data.user);
      toast.success(`Bienvenido, ${data.user.name.split(" ")[0]}`);
      navigate(data.user.role === "admin" ? "/admin" : "/panel");
    } catch (err) {
      toast.error(apiErr(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <div className="max-w-md mx-auto px-4 py-16">
        <div className="overline text-brand mb-2">Acceso</div>
        <h1 className="font-display font-black text-4xl tracking-tighter mb-8">INGRESAR</h1>
        <form onSubmit={submit} className="space-y-4">
          <div><Label>Correo</Label><Input type="email" required data-testid="login-email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} /></div>
          <div><Label>Contraseña</Label><Input type="password" required data-testid="login-password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} /></div>
          <button type="submit" disabled={loading} data-testid="login-submit"
            className="w-full h-11 bg-brand text-black font-semibold hover:bg-brand-hover transition-colors disabled:opacity-60">
            {loading ? "Ingresando..." : "Ingresar"}
          </button>
        </form>
        <p className="text-sm text-muted-foreground text-center mt-6">
          ¿No tienes cuenta? <Link to="/registro" className="text-brand font-semibold">Regístrate</Link>
        </p>
      </div>
    </div>
  );
}
